import React from 'react'
import classNames from 'classnames'

import { getEmojiNativeText } from './utils'

class Emoji extends React.PureComponent {
  render() {
    const {
      emoji,
      size = 32,
      fontSize = Math.trunc(size * 0.75),
      className,
      style = {},
      ...props
    } = this.props
    return (
      <div
        alt={emoji.id}
        className={classNames(
          'flexbox flexbox-centered radius-normal center-text',
          className
        )}
        style={{
          ...style,
          width: size,
          height: size,
        }}
        {...props}
      >
        <span
          style={{
            lineHeight: `1.2em`,
            display: 'inline-block',
            fontSize,
            textAlign: 'center',
            wordBreak: 'keep-all', // fix ff display issue for compounded emojis like 👩‍✈️
            width: size,
          }}
        >
          {getEmojiNativeText(emoji)}
        </span>
      </div>
    )
  }
}

export default Emoji
